module.exports = __webpack_public_path__ + "media/Main-Page-McCormick.fcdbd4e5.webm";